export const ROUTER_PATHS = {
  ORGANIZATION_PICKER: '/organization-picker',
  SWITCH_ORGANIZATION: '/switch-organization',
  NOT_FOUND: '/404',
  SERVER_ERROR: '/500',
  ERROR: '/error',
  FORBIDDEN: '/forbidden',
  PRODACTIVE_NOT_ENABLED: '/prodactive-not-enabled',
  ORDERS: '/orders',
  ORDER_DETAILS: '/orders/[id]',
  PRODUCTION_ORDERS: '/production-orders',
  PRODUCTION_ORDER_DETAILS: '/production-orders/[id]',
  WORK_RECORDS: '/work-records',
  SANDBOX: '/sandbox',
  SHOP_FLOORS: '/shop-floors',
  SHOP_FLOOR_DETAILS: '/shop-floors/[id]',
  SHOP_FLOOR_ALL_DETAILS: '/shop-floors/all/[id]',
  EARNING_REPORT: '/earning-report',
  PERFORMANCE_REPORT: '/performance-report',
  INCOME_REPORT: '/income-report',
  REPORTS: '/reports',
  PLANNING: '/planning',
  ADMINISTRATION: '/administration',
  ADMINISTRATION_RATES: '/administration/rates'
}
